var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOutline = function SvgEyeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.566 12.004c0 1.435-1.147 2.595-2.566 2.595-1.419 0-2.565-1.16-2.565-2.595 0-1.436 1.146-2.596 2.565-2.596 1.42 0 2.566 1.16 2.566 2.596Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 18c2.53 0 4.888-1.508 6.529-4.118.321-.51 1.47-1.193 1.471-1.877 0-.687-1.148-1.374-1.471-1.887C16.888 7.508 14.529 6 12 6c-2.53 0-4.888 1.508-6.529 4.118-.323.513-1.472 1.2-1.471 1.887 0 .684 1.15 1.367 1.471 1.877C7.112 16.492 9.471 18 12 18Z"
  })));
};
export default SvgEyeOutline;